export interface NavLink {
  label: string
  href: string
}

export const NAV_LINKS: NavLink[] = [
  { label: 'How it works', href: '#how-it-works' },
  { label: 'For singles', href: '#for-singles' },
  { label: 'For venues', href: '#for-venues' },
  { label: 'Trust', href: '#trust' },
  { label: 'About', href: '#about' },
]
